<template>
  <motlet :options="motletOptions">
    <template #content>
      <!-- eslint-disable-next-line prettier/prettier -->
      <bar-horizontal-stack
        ref="barHorizontalStackChart"
        :system="system"
        :items="instances"
        :values="values"
        :selected-descendant.sync="selectedDescendant"
        :contextmenu="contextmenuChart"
      />
    </template>
    <template #menu>
      <contextmenu :options="contextmenuParam"></contextmenu>
    </template>
  </motlet>
</template>

<script>
import instanceable from './mixins/instanceable';
import contextmenuable from './mixins/contextmenuable';
import BarHorizontalStack from '../chart/BarHorizontalStackNeo2.vue';

export default {
  mixins: [instanceable, contextmenuable],
  components: {
    BarHorizontalStack,
  },
  data() {
    return {
      msgName: 'cntWorkprcsTypeStatus',
      msgFields: ['wpItype', 'wpIstatus', 'cnt'],
      msgSeq: 0,
      values: [],
      valueBuffer: [],
      contextmenuUrl: '/views/detailview/abap/process',
      selectedDescendant: {},
    };
  },
  watch: {
    instances: {
      handler: 'changeInstancesHandler',
    },
  },
  computed: {
    motletOptions() {
      return {
        id: 'overview/system/abap/WorkProcess',
        title: this.$t('ov.sys.title.workprcs'),
      };
    },
  },
  methods: {
    contextmenuChart(event) {
      this.onContextmenuChart(event, this.selectedDescendant);
    },
    wsDataHandler(key, response) {
      // cntWorkprcsTypeStatus 레코드들을
      // 인스턴스 별/Type별/Status별 건수 데이터로 변환한다.
      let instValue = this.valueBuffer.find(v => v.id == key.instId);
      if (instValue === undefined) {
        instValue = { id: key.instId, data: [] };
        this.valueBuffer.push(instValue);
      }
      let instData = instValue.data;
      response.forEach(rspn => {
        let instTypeStatus = instData.find(id => id[0] == parseInt(rspn.wpItype) && id[1] == parseInt(rspn.wpIstatus));
        if (instTypeStatus === undefined) {
          instTypeStatus = [parseInt(rspn.wpItype), parseInt(rspn.wpIstatus), 0];
          instData.push(instTypeStatus);
        }
        instTypeStatus[2] = parseInt(rspn.cnt);
      });
      // 인스턴스 개수만큼 데이터를 다 받으면 차트에게 알려준다.
      if (this.valueBuffer.length == this.instances.length) {
        this.values = this.valueBuffer; // 이 라인을 $nextTick() 내부로 옮기면 안됨. 데이터가 할당이 안됨.2023.07.19.KWShin.
        this.$nextTick(() => {
          this.$refs.barHorizontalStackChart.changeValuesHandler();
        });
        this.valueBuffer = [];
      }
    },
    sendMessage() {
      this.$websocket.realtime.send({
        requests: this.instances.map(instance => ({
          key: { name: this.msgName, sstmId: instance.systemId, instId: instance.id },
          fields: this.msgFields,
          empty: false,
          handler: {
            every: this.wsDataHandler,
          },
        })),
      });
    },
    initialize() {
      this.msgSeq = 0;
      this.values = [];
      this.valueBuffer = [];
    },
    changeInstancesHandler() {
      this.initialize();
      this.sendMessage();
    },
  },
};
</script>
